export default __webpack_public_path__ + "static/media/edges-offer.5401b8ed.png";